<template>
  <div class="content-wrapper">
    <div class="settings">
      <ConfigFilters
        v-if="showFilters"
        :availableInsightsFilters="availableInsightsDimensions"
        :availableShopperIntelligenceFilters="availableShopperIntelligenceDimensions"
        :selectedBasicFilters="selectedProps.basicFilters"
        :selectedAdvancedFilters="selectedProps.advancedFilters"
        :filterType="selectedProps.filterType"
        :dateRange="dateRange"
        :brandIds="brandIds"
        :portfolioBrands="portfolioBrands"
        @selectFilterType="$emit('selectFilterType', $event)"
        @updateBasicFilters="$emit('updateBasicFilters', $event)"
        @updateAdvancedFilters="$emit('updateAdvancedFilters', $event)"
      />
      <ConfigDimensionMetrics
        v-else
        :selectedDimension="selectedProps.dimension"
        :includeFullSegments="selectedProps.includeFullSegments"
        :metricsList="selectedProps.metricsList"
        :availableShopperIntelligenceSegments="availableShopperIntelligenceDimensions"
        :isAllSegmentsInactive="isAllSegmentsInactive"
        @setDimension="$emit('setDimension', $event)"
        @handleIncludeFullSegments="$emit('handleIncludeFullSegments', $event)"
        @updateMetrics="$emit('updateMetricsFromConfig')"
      />
    </div>
    <Preview
      :selectedBrands="selectedProps.brands"
      :selectedDimension="selectedProps.dimension"
      :selectedMetrics="selectedProps.metrics"
      :selectedBasicFilters="selectedProps.basicFilters"
      :selectedAdvancedFilters="selectedProps.advancedFilters"
      :filterType="selectedProps.filterType"
      :showFilters="showFilters"
      :portfolioBrands="portfolioBrands"
      :availableShopperIntelligenceSegments="availableShopperIntelligenceDimensions"
      @updateBrands="$emit('updateBrands', $event)"
      @updateMetrics="$emit('updateMetricsFromPreview', $event)"
      @removeFilter="$emit('removeFilterFromPreview', $event)"
      @removeAllAdvancedFilters="$emit('removeAdvancedFiltersFromPreview')"
      @addFilters="$emit('addFilters')"
      @openFilters="$emit('addFilters')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ConfigFilters from
  './Filters/ConfigureFilters.vue';
import ConfigDimensionMetrics from
  './DimensionAndMetrics/ConfigureDimensionMetrics.vue';
import Preview from
  './Preview/Preview.vue';
import {
  getFormattedDateRange,
} from '../../../../../services/dashboard/dates/datesService';

export default {
  props: {
    selectedProps: {
      type: Object,
    },
    portfolioBrands: {
      type: Array,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: true,
    },
    availableInsightsDimensions: {
      type: Array,
      required: true,
    },
    availableShopperIntelligenceDimensions: {
      type: Array,
      required: true,
    },
    brandIds: Array,
    isAllSegmentsInactive: Boolean,
  },
  components: {
    ConfigFilters,
    ConfigDimensionMetrics,
    Preview,
  },
  computed: {
    ...mapState({
      storedStartDate: state => state.dashboard.reportRequest.startDate,
      storedEndDate: state => state.dashboard.reportRequest.endDate,
    }),
    dateRange() {
      return getFormattedDateRange(
        this.storedStartDate,
        this.storedEndDate,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  flex-direction: row;
  padding: 24px;
  .settings {
    width: 788px;
    height: 100%;
  }
}
</style>
